import { render, staticRenderFns } from "./ContactRow.vue?vue&type=template&id=cf2c765c&scoped=true&"
import script from "./ContactRow.vue?vue&type=script&lang=js&"
export * from "./ContactRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf2c765c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/Weboldal/weboldal/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {VBtn,VIcon})
